import { Pipe, PipeTransform } from '@angular/core';
import { formatMeetingAuditFieldName } from '@app/shared/utils/helper';

/**
 * Transforms a snake_case attribute name to a human-readable field label.
 * Example: 'meeting_id' -> 'Meeting ID'
 */
@Pipe({
  name: 'auditFieldLabel',
  standalone: true,
  pure: true,
})
export class AuditFieldLabelPipe implements PipeTransform {
  public transform(attributeName: string): string {
    return formatMeetingAuditFieldName(attributeName);
  }
}
